import {store} from "../store/store";
import axios from "axios"
import jwt from "jsonwebtoken";

export const iamCan = (action, domain_id, resource) => {
          // guard function to decide whether a given action can be perforrmed
          // given current access token.
          var decoded_token = jwt.decode(store.state.accessToken)

          for (var role_entry of decoded_token["iam:roles"]) {
            // Check if domain matches.  ADMIN of id 0 matches all
            if ((role_entry["domain_id"] == 0 && role_entry["role"] == "ADMIN")
                || (role_entry["domain_id"] == domain_id)) {
                for (var permission of role_entry["permissions"]) {
                    // Check for action match
                    if (permission["action"] == "iam:*"
                        || permission["action"] == "iam:" + action) {
                        // check resource match
                        if ( permission["resource"] == "*"
                           || permission["resource"] == resource) {
                              return true;
                        }
                    }
                }
            }
          }
          return false;

}

export const getDomains = () => {
    return store.dispatch('getAccessToken').then(token => {
        return axios.get(`/iam/v1/domains`,
            {
                headers: {Authorization: "Bearer " + token}
            })
            .then(resp => resp.data.domains)
    })
};

export const getDomainsWithAssociationCount = () => {
    return store.dispatch('getAccessToken').then(token => {
        return axios.get(`/iam/v1/domains?with_role_count=true`,
            {
                headers: {Authorization: "Bearer " + token}
            })
            .then(resp => resp.data.domains)
    })
};

export const createDomain = (domain_name) => {
    return store.dispatch('getAccessToken').then(token => {
        return axios.post(`/iam/v1/domains`,
            JSON.stringify({name: domain_name}),
            {
                headers: {
                  Authorization: "Bearer " + token,
                  "Content-Type": 'application/json',
                }
            })
            .then(resp => resp.data)
    })
};

export const deleteDomain = (domain_id) => {
    return store.dispatch('getAccessToken').then(token => {
        return axios.delete(`/iam/v1/domains/${domain_id}`,
            {
                headers: {
                  Authorization: "Bearer " + token,
                }
            })
            .then(resp => resp.data)
    })
};

export const getUsers = () => {
    return store.dispatch('getAccessToken').then(token => {
        return axios.get(`/iam/v1/users`,
            {
                headers: {Authorization: "Bearer " + token}
            })
            .then(resp => resp.data.users)
    })
};

export const getUsersWithRoles = () => {
    return store.dispatch('getAccessToken').then(token => {
        return axios.get(`/iam/v1/users`,
            {
                headers: {Authorization: "Bearer " + token}
            })
            .then(resp => {
              var users = {};
              for(var user of resp.data.users) {
                users[user.username] = {
                  username: user.username,
                  email: user.email,
                  roles: [],
                  enabled: user.enabled,
                  created_at: user.user_create_date,
                };
              }

              return axios.get(`/iam/v1/role_associations`,
                {
                    headers: {Authorization: "Bearer " + token}
                })
                .then(resp => {
                  var role_associations = resp.data.role_associations;
                  for (var role_association of role_associations) {
                    if (role_association.username in users) {
                      users[role_association.username].roles.push({
                        id: role_association.id,
                        domain_id: role_association.domain_id,
                        domain_name: role_association.domain_name,
                        role_id: role_association.role,
                        role_name: role_association.role,
                      })
                    }
                  }
                  return Object.values(users);
                })

            })

    })
};

export const getRoles = () => {
    return store.dispatch('getAccessToken').then(token => {
        return axios.get(`/iam/v1/roles`,
            {
                headers: {Authorization: "Bearer " + token}
            })
            .then(resp => resp.data.roles)
    })
};

export const createRoleAssociation = (username, domain_id, role_id) => {
    return store.dispatch('getAccessToken').then(token => {
        return axios.post(`/iam/v1/role_associations`,
            JSON.stringify({
              username: username,
              domain_id: domain_id,
              role_id: role_id,
            }),
            {
                headers: {
                  Authorization: "Bearer " + token,
                  "Content-Type": 'application/json',
                }
            })
            .then(resp => resp.data)
    })
};

export const deleteRoleAssociation = (id) => {
    return store.dispatch('getAccessToken').then(token => {
        return axios.delete(`/iam/v1/role_associations/${id}`,
            {
                headers: {
                  Authorization: "Bearer " + token,
                }
            })
    })
};

export const disableUser = (username) => {
    return store.dispatch('getAccessToken').then(token => {
        return axios.post(`/iam/v1/users/${username}/disable`,
            null,
            {
                headers: {
                  Authorization: "Bearer " + token,
                }
            })
    })
};

export const enableUser = (username) => {
    return store.dispatch('getAccessToken').then(token => {
        return axios.post(`/iam/v1/users/${username}/enable`,
            null,
            {
                headers: {
                  Authorization: "Bearer " + token,
                }
            })
    })
};

export const createUser = (username) => {
    return store.dispatch('getAccessToken').then(token => {
        return axios.post(`/iam/v1/users`,
            JSON.stringify({
              email: username,
            }),
            {
                headers: {
                  Authorization: "Bearer " + token,
                  "Content-Type": "application/json",
                }
            })
            .then(resp => resp.data)
    })

}
